export default "__VITE_ASSET__CKx1PEZd__"